// @flow

import * as React from 'react';

import FormSubmitButtons from '../form_submit_buttons';
import type { ModalProps } from './shared';

import { Container, Header, Content, Footer, Modal } from './modal';

import useModal from './use_modal';

type InformationModalProps = ModalProps & {
  children?: React.Element<any>,
  modalContent?: React.Element<any>,
  submitText?: string,
  disabled?: boolean,
};

const InformationModal = (props: InformationModalProps) => {
  const {
    children,
    title,
    fullWidth,
    maxWidth,
    modalContent,
    submitText,
    disabled,
    displayXIcon,
    modalBodyOverflow,
  } = props;
  const [open, openModal, closeModal] = useModal(props.open);

  return (
    <React.Fragment>
      {children &&
        React.cloneElement(children, {
          onClick: openModal,
        })}
      <Modal>
        <Container
          open={open}
          closeModal={closeModal}
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          draggable={false}
        >
          <Header
            title={title}
            draggable={false}
            closeModal={closeModal}
            displayXIcon={displayXIcon}
          />
          <Content dividers={false} modalBodyOverflow={modalBodyOverflow}>
            {modalContent}
          </Content>
          <Footer>
            <FormSubmitButtons
              fancy
              compact
              hideCancelButton
              onSubmit={closeModal}
              submitText={
                submitText || FormSubmitButtons.defaultProps.submitText
              }
              disabled={disabled}
            />
          </Footer>
        </Container>
      </Modal>
    </React.Fragment>
  );
};

export default InformationModal;

InformationModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  displayXIcon: true,
};
